<template>
  <div class="charts_el" ref="chartsEl" :style="getWidth()"></div>
</template>

<script>
import * as echarts from "echarts";
export default {
  name: "GjkcH5DifficultProportionPie",
  props: {
    width: {
      default: 500,
    },
    height: {
      default: 500,
    },
  },

  data() {
    return {};
  },

  mounted() {
    // this.initCharts();
  },

  methods: {
    initCharts(chartsData) {
      var chartDom = this.$refs.chartsEl;
      var myChart = echarts.init(chartDom);
      var option;

      option = {
        title: {
          text: "",
          subtext: "",
          left: "center",
        },
        tooltip: {
          trigger: "item",
        },
        legend: {
          orient: "vertical",
          left: "right",
          top:'20px',
          formatter(name) {
            let info = chartsData.find((item) => item.name == name);

            return `${name}   ${info.value}%`;
          },
        },
        color: ["#FCDD68", "#87DDFF", "#FF83A4", "#0355FE", "#ee6666"],
        series: [
          {
            // name: "Access From",
            type: "pie",
            radius: ["40%", "70%"],
            // data: [
            //   { value: 1048, name: "Search Engine" },
            //   { value: 735, name: "Direct" },
            //   { value: 580, name: "Email" },
            //   { value: 484, name: "Union Ads" },
            //   { value: 300, name: "Video Ads" },
            // ],
            data: chartsData,
            stillShowZeroSum: true,
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
            label: {
              show: true,
              formatter: "{d|{d}%} \n {b|{b}}",
              position:"outside",
              rich: {
                d: {
                  color:"inherit",
                  fontSize: 16,
                  lineHeight: 24,
                  height: 24
                },
                b: {
                  color: "#ccc",
                  fontSize: 12,
                  lineHeight: 16,
                  align: 'left',
                }
              },
            }
          },
        ],
      };

      option && myChart.setOption(option);
    },
    getWidth() {
      if (!this.width) return;
      return {
        width: this.width + "px",
        height: this.height + "px",
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.charts_el {
  width: 100%;
  height: 100%;
  position: relative;
}
</style>
